import { Anchor, Flex, Group, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Content, EditButtonLink } from '@/core/components';

import { formatDate } from '@feature/utils';

import { mobilityTitle } from './MobilityUtils';
import { MobilityDeleteButton } from './components/MobilityDeleteButton';
import { MobilityCertificate } from './components/certificate/MobilityCertificate';
import { Mobility } from './model/MobilityTypes';

interface MobilityViewProps {
  mobility: Mobility;
}

export function MobilityView({ mobility }: MobilityViewProps) {
  const { t } = useTranslation();
  const { startDate, endDate, sourceTravelRequestId } = mobility;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{mobilityTitle(t, mobility)}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <MobilityDeleteButton mobilityId={mobility.id} />
            </Group>
          </Flex>
          <Text size="sm">
            {t('mobilities.details.period')}: {formatDate(startDate)} - {formatDate(endDate)}
          </Text>
          {sourceTravelRequestId != null && (
            <Anchor
              size="sm"
              renderRoot={rootProps => (
                <Link
                  to="/travel/requests/$requestId"
                  params={{ requestId: String(sourceTravelRequestId) }}
                  {...rootProps}
                />
              )}
            >
              {t('mobilities.details.sourceRequest')}
            </Anchor>
          )}
        </Stack>
      </Content>
      <Content type="full">
        <MobilityCertificate mobility={mobility} />
      </Content>
    </Stack>
  );
}
